(function() {

  em.sideHeader = {};

  em.sideHeader.init = function() {
    var nav = document.querySelector(".js-side-navigation");

    if (nav === null) {
      return false;
    }

    // Do not look the menu up by its id. wp_nav_menu() builds that id from the
    // menu slug and suffixes it ("-1") when the same menu is output twice in a
    // page, which is exactly what happens here: the header nav renders first
    // and takes #menu-primary-navigation, leaving the side nav with a
    // different id. Match on the menu class instead, which we set ourselves.
    var menu = nav.querySelector('.c-side-navigation__items');

    if (menu !== null) {
      em.sideHeader.setupMenuLinksWithSubMenus(menu);
    }

    em.sideHeader.setupMenuToggles();

    em.sideHeader.closeMenuOnFocusWithin(document.getElementById('c-overlay'));

  };

  em.sideHeader.setupMenuToggles = function() {
    var toggleEl = document.querySelector('.js-navigation-toggle');
    toggleEl.addEventListener('click', function(e) {
      e.preventDefault();
      document.body.classList.toggle('has-open-mobile-menu');
    });

    var closeBtn = document.querySelector('.js-navigation-close');
    closeBtn.addEventListener('click', function(e) {
      e.preventDefault();
      document.body.classList.toggle('has-open-mobile-menu');
    });
  };

  em.sideHeader.setupMenuLinksWithSubMenus = function(menu) {
    // Every level, not just the top one: the menu now nests the disciplines
    // under a single top level item.
    var els = menu.querySelectorAll('li.has-children');
    for (var i = 0; i < els.length; i++) {
      em.sideHeader.toggleSubMenu(els[i]);
    }
  };

  em.sideHeader.toggleSubMenu = function(el) {
    if (el.classList.contains('is-active-parent')){
      el.classList.add('is-open');
      el.setAttribute('aria-expanded', 'true');
    } else {
      el.setAttribute('aria-expanded', 'false');
    }

    // Bind the item's own row rather than the whole <li>, so a click inside an
    // open submenu does not also collapse its parents.
    for (var i = 0; i < el.children.length; i++) {
      var child = el.children[i];

      if (child.tagName !== 'A' && !child.classList.contains('js-toggle-button')) {
        continue;
      }

      child.addEventListener('click', function(e) {
        // A parent item is a submenu handle, not a link: its own page is not
        // meant to be reachable.
        e.preventDefault();
        e.stopPropagation();

        if (el.classList.contains('is-open')) {
          el.classList.remove('is-open');
          el.setAttribute('aria-expanded', 'false');
          return;
        }

        // Close the other open items at this level only.
        var siblings = el.parentNode.children;
        for (var j = 0; j < siblings.length; j++) {
          if (siblings[j] !== el && siblings[j].classList.contains('has-children')) {
            siblings[j].classList.remove('is-open');
            siblings[j].setAttribute('aria-expanded', 'false');
          }
        }

        el.classList.add('is-open');
        el.setAttribute('aria-expanded', 'true');
      });
    }
  };

  em.sideHeader.closeMenuOnFocusWithin = function(el) {
    if (el === null) {
      return false;
    }

    el.addEventListener('click',function() {
        document.body.classList.remove('has-open-mobile-menu', 'has-open-grid-modal');
      },{ passive: true }
    );
  };

})();
